import {gql} from "@apollo/client";

// Reports of one installed base node (Risk reports tab). The API offers no
// status filter and no sorting — both happen client-side.
// NOTE: do not select createdBy here — the subgraph currently answers any
// createdBy selection with an internal server error (backend in development).
export const RiskAssessmentReportList = gql`
    query RiskAssessmentReportList($filter: RiskAssessmentReportListFilter, $pagination: Pagination) {
        riskAssessmentReportList(filter: $filter) {
            total
            riskAssessmentReports(pagination: $pagination) {
                id
                title
                status
                reportType
                startDate
                endDate
                insert
            }
        }
    }
`;
